module.exports = __webpack_public_path__ + "img/14e7121.jpg";